import axios from "axios";
import { getAiChatConfig, getStoredAiChatConfig } from "../postgre/aiChatConfigApi";

// Normally already cached in localStorage right after login (see
// refreshAiChatConfig in aiChatConfigApi.js, called from context/index.js).
// This is a fallback for the rare case it isn't there yet (e.g. storage
// cleared, or a request fires before the background refresh finishes) —
// fetched once and cached in-memory for the rest of this page load.
let fetchedConfigPromise = null;
const resolveConfig = () => {
    const stored = getStoredAiChatConfig();
    if (stored?.baseUrl) return Promise.resolve(stored);

    if (!fetchedConfigPromise) {
        fetchedConfigPromise = getAiChatConfig().catch((error) => {
            fetchedConfigPromise = null;
            throw error;
        });
    }
    return fetchedConfigPromise;
};

const aiagentApi = axios.create({
    headers: {
        "Content-Type": "application/json",
        "X-Tenant": "korres",
    },
});

aiagentApi.interceptors.request.use(async (config) => {
    const { baseUrl, auth } = await resolveConfig();
    config.baseURL = baseUrl;
    if (auth) config.headers.Authorization = auth;
    return config;
});

// Streaming (SSE) responses need a raw ReadableStream — axios's browser (XHR)
// adapter buffers the whole body, so this uses fetch directly instead, with
// the same resolved config as the axios instance above.
const streamAiagent = async (url, data) => {
    const { baseUrl, auth } = await resolveConfig();
    return fetch(`${baseUrl}${url}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": auth || "",
            "X-Tenant": "korres",
        },
        body: JSON.stringify(data),
    });
};

const aiagentApiService = {
    get: (url, config = {}) => aiagentApi.get(url, config),
    post: (url, data, config = {}) => aiagentApi.post(url, data, config),
    patch: (url, data, config = {}) => aiagentApi.patch(url, data, config),
    delete: (url, config = {}) => aiagentApi.delete(url, config),
    stream: streamAiagent,
};

export default aiagentApiService;
